export default __webpack_public_path__ + "static/media/ok_orange_icon.74d57e71.svg";